<template>
    <div class="loader"></div>
</template>

<style scoped>
.loader {
    width: 60px;
    height: 60px;
    border: 5px solid #B5AFBF;
    border-radius: 50%;
    display: block;
    animation: rotation 1s linear infinite;
    position: absolute;
    z-index: 999999;
    left: 0; 
    right: 0; 
    margin-left: auto; 
    margin-right: auto; 
     
} 
.loader::after {
    content: '';  
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 90px;
    height: 90px;
    border-radius: 50%;
    border: 5px solid transparent;
    border-bottom-color: #7440D4;
}

@keyframes rotation {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
} 
</style>